import { Link, Typography } from '@mui/material';
import type { Sx } from '@/types/helpers';

import { SUPPORT_EMAIL } from '@/constants/constants';

export const SupportContact = ({ sx }: { sx?: Sx }) => (
  <Typography sx={sx}>
    Any issues? Drop us a line at{' '}
    <Link
      color='gx.text'
      href={`mailto:${SUPPORT_EMAIL}`}
      sx={{ whiteSpace: 'nowrap' }}
      target='_top'
    >
      {SUPPORT_EMAIL}
    </Link>
  </Typography>
);
